const ErrorComponent = ({ errors }) => {
  return <p>{JSON.stringify(errors)}</p>;
};

export default ErrorComponent;
